// hooks/useSnackbar.js
import { useState } from 'react';

const useSnackbar = () => {
    const [snackbar, setSnackbar] = useState({
        message: '',
        color: 'success',
        trigger: 0
    });

    const showSuccess = (message) => {
        setSnackbar(prev => ({
            message,
            color: 'success',
            trigger: prev.trigger + 1
        }));
    };

    const showError = (message) => {
        setSnackbar(prev => ({
            message,
            color: 'error',
            trigger: prev.trigger + 1
        }));
    };

    const showWarning = (message) => {
        setSnackbar(prev => ({
            message,
            color: 'warning',
            trigger: prev.trigger + 1
        }));
    };

    const showInfo = (message) => {
        setSnackbar(prev => ({
            message,
            color: 'info',
            trigger: prev.trigger + 1
        }));
    };

    return {
        snackbar,
        showSuccess,
        showError,
        showWarning,
        showInfo
    };
};

export default useSnackbar;